





















































import {
  defineComponent,
  computed,
  toRefs,
  useContext,
  ref
} from '@nuxtjs/composition-api'
import { useApp } from '~/compositions/app'

const ONLY_TRADES_DISMISSED_COOKIE = 'onlyTradesDismissed'

export default defineComponent({
  props: {
    classifiedId: { type: Number, required: true },
    ownerOrAdmin: { type: Boolean, required: true }
  },
  setup(props) {
    const { isCar } = useApp()
    const { classifiedId } = toRefs(props)
    const { app } = useContext()
    const getOnlyTradesCookie = () => {
      return JSON.parse(app.$cookies.get(ONLY_TRADES_DISMISSED_COOKIE) || '{}')
    }
    const isDismissed = ref(
      getOnlyTradesCookie()?.[classifiedId.value] || false
    )
    const isEn = computed(() => app.i18n.locale === 'en')
    const editUrl = computed(() =>
      isCar.value
        ? `/classifieds/cars/edit/${classifiedId.value}/#details`
        : `/classifieds/${classifiedId.value}/edit`
    )

    const handleDismissed = () => {
      const cookieData = getOnlyTradesCookie()
      cookieData[classifiedId.value] = true
      app.$cookies.set(ONLY_TRADES_DISMISSED_COOKIE, JSON.stringify(cookieData))
    }
    return { isEn, editUrl, handleDismissed, isDismissed }
  }
})
